<template>
  <v-data-iterator
    :items="items"
    :server-items-length="items_total"
    :items-per-page="items_per_page"
    :loading="loading"
    :page.sync="current_page"
    v-on:update:page="paginate"
    :hide-default-footer="true"
    disable-pagination
    v-bind="iterator_configuration"
    :footer-props="{
		showFirstLastPage: true,
		disableItemsPerPage: true,
	}"
  >
    <template v-slot:default="{ items, isExpanded, expand }">
      <v-layout wrap>
        <v-flex v-for="item in items" :key="item.uuid" v-bind="grid_params">
          <slot v-bind="item"></slot>
        </v-flex>
      </v-layout>
    </template>

    <template v-slot:loading>
      <div class="text-center py-5 my-5">
        <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
      </div>
    </template>

    <template v-slot:no-data>
      <slot name="no-data"></slot>
    </template>

    <template v-slot:footer>
      <v-pagination
        v-model="current_page"
        :length="last_page"
        :total-visible="5"
        :disabled="loading"
        circle
      ></v-pagination>
    </template>
  </v-data-iterator>
</template>
<script>
export default {
  props: ["pagination", "loading", "grid", "iteratorConfig"],

  computed: {
    items: function() {
      return _.get(this.$props.pagination, "data", []);
    },

    items_per_page: function() {
      return _.get(this.$props.pagination, "parseInt(per_page)", 15);
    },

    last_page: function() {
      return _.get(this.$props.pagination, "last_page", 1);
    },

    current_page: {
      get: function() {
        return _.get(this.$props.pagination, "current_page", 1);
      },
      set: function(page) {
        this.$emit("paginate", page);
      }
    },

    items_total: {
      get: function() {
        return _.get(this.$props.pagination, "total", 0);
      },
      set: function(value) {
        return;
      }
    },

    grid_params: function() {
      if (_.has(this.$props, "grid")) {
        return this.$props.grid;
      } else {
        return { xs12: true };
      }
    },

    iterator_configuration: function() {
      _.get(this.$props, "iteratorConfig", {});
    }
  },

  methods: {
    paginate: function(page) {
      this.$vuetify.goTo(0);
      // this.$emit('paginate', page);
    }
  }
};
</script>